module.exports = __webpack_public_path__ + "static/worker-build-reputation-1249933031ec4d9de86a28df56edda43.png";